/**
 * Formatting helpers. Centralised so currency / number rendering stays
 * consistent across the site.
 */

const usdFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

const usdCompactFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  notation: "compact",
  maximumFractionDigits: 1,
});

export function formatUsd(amount: number): string {
  return usdFormatter.format(amount);
}

export function formatUsdCompact(amount: number): string {
  return usdCompactFormatter.format(amount);
}
